// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sfsBtwDSTHHXhOHlj3Zm {
	background-color: var(--gray);
	display: flex;
	flex-direction: column;
}

.c4PMlXEOLkoGL63IUp9l {
	padding: 20px 32px;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
}

.o3svSPZdlToqpkmwzXYU {
	padding: 20px 32px 32px;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
}
`, "",{"version":3,"sources":["webpack://./src/pages/CreateLockPage/CreateLockPage.pcss"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,4CAA4C;AAC7C;;AAEA;CACC,uBAAuB;CACvB,4CAA4C;AAC7C","sourcesContent":[".content {\n\tbackground-color: var(--gray);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.input {\n\tpadding: 20px 32px;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.date {\n\tpadding: 20px 32px 32px;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `sfsBtwDSTHHXhOHlj3Zm`,
	"input": `c4PMlXEOLkoGL63IUp9l`,
	"date": `o3svSPZdlToqpkmwzXYU`
};
export default ___CSS_LOADER_EXPORT___;
